import { render, staticRenderFns } from "./OperationNaturesControl.vue?vue&type=template&id=491c6cfe&scoped=true"
import script from "./OperationNaturesControl.vue?vue&type=script&lang=js"
export * from "./OperationNaturesControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491c6cfe",
  null
  
)

export default component.exports